/* Kronos follicle diagram: multi-blade vs single-blade, drawn over an engraved follicle plate.
   One coordinate space: the plate's 1200x900 grid. Geometry per plate comes from data-* on the <svg>. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  var LOOP = 11;                       // seconds; reset from the shared plan
  var V = 260;                         // edge speed between hairs, units/s
  var VFAST = 900;                     // approach and exit speed
  var CZ = 8;                          // an edge touches the hair at FX-CZ and has cut it by FX+CZ
  var BULB = .35;                      // share of the lift taken by the root bulb; the shaft stretches for the rest
  var PITCH = 66;                      // blade spacing
  var TH = 52 * Math.PI / 180;         // blade lean
  var BL = 210, BT = 12, BEV = 30;     // blade length, thickness, bevel
  var LIFT = [40, 15, 15, 15, 15];     // pull each edge gives the hair before it cuts
  var HW = 15;                         // hair width

  function el(name, attrs, parent) {
    var e = document.createElementNS(NS, name);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function clamp(x, a, b) { return x < a ? a : x > b ? b : x; }
  function seg(t, a, b) { return clamp((t - a) / (b - a), 0, 1); }
  function easeOut(u) { return 1 - Math.pow(1 - u, 3); }
  function easeInOut(u) { return u < .5 ? 4 * u * u * u : 1 - Math.pow(-2 * u + 2, 3) / 2; }
  function herm(p0, p1, v0, v1, dt, u) {
    var u2 = u * u, u3 = u2 * u;
    return (2 * u3 - 3 * u2 + 1) * p0 + (u3 - 2 * u2 + u) * dt * v0 + (-2 * u3 + 3 * u2) * p1 + (u3 - u2) * dt * v1;
  }
  function f(n) { return Math.round(n * 10) / 10; }

  Figure.uid = 0;
  function Figure(svg) {
    var d = svg.dataset;
    this.svg = svg;
    svg.__fig = this;
    this.multi = d.kind === 'multi';
    this.n = this.multi ? 5 : 1;
    this.S = +d.surface || 360;
    this.SL = +d.surfaceLine || this.S + 1.5;
    function num(v, dflt) { return v === undefined || v === '' ? dflt : +v; }
    this.LW = num(d.lineWidth, 4);
    this.HP = num(d.hatchPitch, 4.7);
    this.HWt = num(d.hatchWidth, 1.8);
    this.FX = +d.fx || 600;
    this.RT = +d.rootTop || 700;
    this.RB = +d.rootBottom || 806;
    this.RW = +d.rootWidth || 30;
    this.PT = +d.papillaTop || 760;
    this.PW = +d.papillaWidth || 14;
    this.W = +d.width || 1200;
    this.plan();
    this.build();
  }

  // Swap the engraved ground: new landmarks, same motion.
  Figure.prototype.setGeometry = function (geo) {
    for (var k in geo) this.svg.dataset[k] = geo[k];
    while (this.g.firstChild) this.g.removeChild(this.g.firstChild);
    this.svg.removeChild(this.g);
    var defs = this.svg.querySelector('defs'); if (defs) this.svg.removeChild(defs);
    this._curl = null;
    Figure.call(this, this.svg);
    this.render(this.lastT || 0);
  };

  // Edge motion is integrated once into a table: fast in, slowing to V, slowing hard while any edge is
  // in contact with the hair (the drag), then away fast. Contact and cut times are read off the table.
  function zone(d) {
    if (d < -CZ - 14 || d > CZ + 14) return 0;
    if (d < -CZ) { var a = seg(d, -CZ - 14, -CZ); return a * a * (3 - 2 * a); }
    if (d > CZ) { var b = 1 - seg(d, CZ, CZ + 14); return b * b * (3 - 2 * b); }
    return 1;
  }
  function edgeTable(FX, n, W) {
    var T = [0], X = [-30], t = 0, x = -30, dt = 1 / 240, k;
    while (x < W + (n - 1) * PITCH + 420 && t < 30) {
      var e1 = x - FX, eL = x - (n - 1) * PITCH - FX, v = V, slow = 0;
      if (e1 < -60) v = V + (VFAST - V) * easeInOut(seg(-e1, 60, 300));
      if (eL > 30) v = V + (VFAST - V) * easeInOut(seg(eL, 30, 200));
      for (k = 0; k < n; k++) slow = Math.max(slow, zone(x - k * PITCH - FX));
      v *= (1 - .75 * slow) * easeInOut(seg(t, .6, 1.1));
      t += dt; x += v * dt; T.push(t); X.push(x);
    }
    return { T: T, X: X };
  }
  function whenAt(tab, xv) {
    for (var i = 1; i < tab.X.length; i++) if (tab.X[i] >= xv) {
      var u = (xv - tab.X[i - 1]) / (tab.X[i] - tab.X[i - 1]); return tab.T[i - 1] + u * (tab.T[i] - tab.T[i - 1]);
    }
    return tab.T[tab.T.length - 1];
  }
  var SHARED = null;   // one timeline for both plates, set by the five-blade pass
  function shared(FX, W) {
    if (SHARED) return SHARED;
    var tab = edgeTable(FX, 5, W), cut5 = whenAt(tab, FX + 4 * PITCH + CZ), s = {};
    s.rel0 = cut5 + .2; s.rel1 = s.rel0 + .45;
    s.g0 = s.rel1 + .9; s.g1 = s.g0 + 2.3;
    s.b0 = s.g0 + 1; s.b1 = s.g1 + .2;
    s.r0 = s.g1 + 2.4; s.loop = s.r0 + 1;
    LOOP = s.loop;
    return (SHARED = s);
  }

  Figure.prototype.plan = function () {
    var FX = this.FX, k;
    this.tab = edgeTable(FX, this.n, this.W);
    this.contact = []; this.cross = [];
    for (k = 0; k < this.n; k++) {
      this.contact.push(whenAt(this.tab, FX + k * PITCH - CZ));
      this.cross.push(whenAt(this.tab, FX + k * PITCH + CZ));
    }
    this.E = 0;
    for (k = 0; k < this.n; k++) this.E += this.multi ? LIFT[k] : 0;
    var sh = shared(FX, this.W);
    if (this.svg.dataset.ownTimeline !== undefined && !this.multi) {
      // played on its own: regrow soon after the cut instead of waiting for five blades
      var g0 = this.cross[0] + 1.4;
      sh = { rel0: 0, rel1: 0, g0: g0, g1: g0 + 2.2, b0: g0, b1: g0, r0: g0 + 4, loop: g0 + 5 };
    }
    this.rel0 = this.multi ? sh.rel0 : 0;
    this.rel1 = this.multi ? sh.rel1 : 0;
    this.sh = sh;
  };

  Figure.prototype.edgeX = function (t) {   // leading edge
    var T = this.tab.T, X = this.tab.X;
    if (t <= 0) return X[0];
    var i = Math.min(T.length - 1, Math.ceil(t * 240));
    if (i >= T.length - 1) return X[X.length - 1] + 400;
    var u = (t - T[i - 1]) / (T[i] - T[i - 1]);
    return X[i - 1] + u * (X[i] - X[i - 1]);
  };

  Figure.prototype.build = function () {
    var svg = this.svg, g = el('g', { 'class': 'fd-live' }, svg);
    this.g = g;
    var id = 'fdclip' + (++Figure.uid);
    var defs = el('defs', {}, svg), cp = el('clipPath', { id: id }, defs);
    this.bumpClip = el('path', {}, cp);
    this.bump = el('g', { 'class': 'fd-bump' }, g);
    var hatch = el('g', { 'clip-path': 'url(#' + id + ')' }, this.bump), hd = '', pitch = this.HP;
    for (var y = this.SL - pitch; y > this.S - 40; y -= pitch) hd += 'M' + (this.FX - 60) + ' ' + f(y) + 'H' + (this.FX + 150);
    el('path', { 'class': 'fd-band', d: hd, style: 'stroke-width:' + this.HWt }, hatch);
    this.bumpKnock = el('path', { 'class': 'fd-knock', style: 'stroke-width:' + (this.LW + 3) }, this.bump);
    this.bumpLine = el('path', { 'class': 'fd-line', style: 'stroke-width:' + this.LW }, this.bump);
    var hg = this.hairs = el('g', { 'class': 'fd-hairs' }, g);
    this.root = el('path', { 'class': 'fd-hair-fill' }, hg);
    this.shaft = el('path', { 'class': 'fd-hair' }, hg);
    this.regrow = el('path', { 'class': 'fd-hair-fill' }, hg);
    this.stub = el('path', { 'class': 'fd-hair-fill' }, hg);
    this.top = el('path', { 'class': 'fd-hair-fill' }, hg);
    this.piece = el('path', { 'class': 'fd-hair-fill' }, g);
    this.blades = [];
    for (var k = 0; k < this.n; k++) {
      var b = el('g', { 'class': this.multi ? 'fd-blade' : 'fd-blade fd-blade--gold' }, g);
      el('path', { 'class': 'fd-steel' }, b);
      el('path', { 'class': 'fd-glint' }, b);
      this.blades.push(b);
    }
    this.slivers = [];
    for (k = 1; k < this.n; k++) this.slivers.push(el('path', { 'class': 'fd-hair-fill' }, g));
    // depth measure: a gold rule along skin level from the follicle to the measure, a gold depth rule
    // down to the cut (Fig. 1) or a single level tick (Fig. 2), a dashed mark across the opening, a label in Ovo
    var m = this.measure = el('g', { 'class': 'fd-measure' }, g), FX = this.FX, S = this.S, SL = this.SL, mx = FX + 96, y1 = S + this.E, tk = 14;
    el('path', { 'class': 'fd-dash', d: 'M' + (FX - 30) + ' ' + SL + 'H' + (FX - 11) + 'M' + (FX + 11) + ' ' + SL + 'H' + (FX + 30) }, m);
    el('path', { 'class': 'fd-lead', d: 'M' + (FX + 30) + ' ' + SL + 'H' + mx }, m);
    if (this.multi) {
      el('path', { 'class': 'fd-rule', d: 'M' + mx + ' ' + SL + 'V' + y1 + 'M' + (mx - tk) + ' ' + SL + 'H' + (mx + tk) + 'M' + (mx - tk) + ' ' + y1 + 'H' + (mx + tk) }, m);
      el('path', { 'class': 'fd-dash', d: 'M' + (mx - tk) + ' ' + y1 + 'H' + (FX + 13) }, m);
    } else {
      el('path', { 'class': 'fd-rule', d: 'M' + mx + ' ' + (SL - tk) + 'V' + (SL + tk) }, m);
    }
    var ly = SL + 38, lab = el('text', { 'class': 'fd-label', x: mx + 20, y: f(ly) }, m);
    (this.multi ? ['Below', 'the skin'] : ['Level with', 'the skin']).forEach(function (w, i) {
      var ts = el('tspan', { x: mx + 20, dy: i ? 36 : 0 }, lab); ts.textContent = w;
    });
    this.root.setAttribute('d', this.rootPath());
  };

  Figure.prototype.rootPath = function () {
    // a plain bulb: the shaft swells into a rounded root, no papilla
    var FX = this.FX, RT = this.RT, RB = this.RB, RW = this.RW, h = HW / 2, ym = RT + (RB - RT) * .62;
    return 'M' + (FX - h) + ' ' + RT +
      'C' + (FX - h) + ' ' + (RT + 18) + ' ' + (FX - RW) + ' ' + (ym - 26) + ' ' + (FX - RW) + ' ' + ym +
      'C' + (FX - RW) + ' ' + (RB - 12) + ' ' + (FX - RW * .6) + ' ' + RB + ' ' + FX + ' ' + RB +
      'C' + (FX + RW * .6) + ' ' + RB + ' ' + (FX + RW) + ' ' + (RB - 12) + ' ' + (FX + RW) + ' ' + ym +
      'C' + (FX + RW) + ' ' + (ym - 26) + ' ' + (FX + h) + ' ' + (RT + 18) + ' ' + (FX + h) + ' ' + RT + 'Z';
  };


  // The uncut hair above the skin, base at (bx, by): a long shaft leaning into the stroke,
  // tapering to its natural tip. Returned as a filled outline.
  function longHair(bx, by) {
    var P = [[bx, by], [bx, by - 96], [bx + 18, by - 170], [bx + 74, by - 214]], L = [], R = [];
    for (var i = 0; i <= 24; i++) {
      var u = i / 24, a = 1 - u;
      var x = a * a * a * P[0][0] + 3 * a * a * u * P[1][0] + 3 * a * u * u * P[2][0] + u * u * u * P[3][0];
      var y = a * a * a * P[0][1] + 3 * a * a * u * P[1][1] + 3 * a * u * u * P[2][1] + u * u * u * P[3][1];
      var tx = 3 * a * a * (P[1][0] - P[0][0]) + 6 * a * u * (P[2][0] - P[1][0]) + 3 * u * u * (P[3][0] - P[2][0]);
      var ty = 3 * a * a * (P[1][1] - P[0][1]) + 6 * a * u * (P[2][1] - P[1][1]) + 3 * u * u * (P[3][1] - P[2][1]);
      var m = Math.sqrt(tx * tx + ty * ty) || 1, nx = -ty / m, ny = tx / m;
      var w = HW / 2 * (u < .55 ? 1 : Math.max(.08, 1 - Math.pow((u - .55) / .45, 1.4)));
      L.push(f(x + nx * w) + ' ' + f(y + ny * w)); R.unshift(f(x - nx * w) + ' ' + f(y - ny * w));
    }
    return 'M' + L.join('L') + 'L' + R.join('L') + 'Z';
  }

  // A regrowing hair: full width along its length, drawn to a point over its last few units.
  function spike(pts, taper) {
    var L = [0], i;
    for (i = 1; i < pts.length; i++) L.push(L[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    var tot = L[L.length - 1];
    if (tot < .5) return '';
    var tl = Math.min(taper, tot * .85), Lf = [], Rt = [];
    for (i = 0; i < pts.length; i++) {
      var a = pts[Math.max(0, i - 1)], b = pts[Math.min(pts.length - 1, i + 1)];
      var tx = b[0] - a[0], ty = b[1] - a[1], m = Math.hypot(tx, ty) || 1, nx = -ty / m, ny = tx / m;
      var rem = tot - L[i], w = HW / 2 * (rem >= tl ? 1 : Math.max(0, rem / tl));
      Lf.push(f(pts[i][0] + nx * w) + ' ' + f(pts[i][1] + ny * w)); Rt.unshift(f(pts[i][0] - nx * w) + ' ' + f(pts[i][1] - ny * w));
    }
    return 'M' + Lf.join('L') + 'L' + Rt.join('L') + 'Z';
  }

  Figure.prototype.bladePath = function (ex, ey) {
    var dx = -Math.cos(TH), dy = -Math.sin(TH), nx = Math.sin(TH), ny = -Math.cos(TH);
    var p0 = [ex, ey], p1 = [ex + dx * BEV + nx * BT, ey + dy * BEV + ny * BT],
      p2 = [ex + dx * BL + nx * BT, ey + dy * BL + ny * BT], p3 = [ex + dx * BL, ey + dy * BL];
    var steel = 'M' + f(p0[0]) + ' ' + f(p0[1]) + 'L' + f(p1[0]) + ' ' + f(p1[1]) + 'L' + f(p2[0]) + ' ' + f(p2[1]) + 'L' + f(p3[0]) + ' ' + f(p3[1]) + 'Z';
    var hatch = '';
    [.62].forEach(function (o) {
      var s0 = BEV * (1 - o) + 14;
      hatch += 'M' + f(ex + dx * s0 + nx * BT * o) + ' ' + f(ey + dy * s0 + ny * BT * o) +
        'L' + f(ex + dx * (BL - 10) + nx * BT * o) + ' ' + f(ey + dy * (BL - 10) + ny * BT * o);
    });
    return [steel, hatch];
  };

  // Hair state at time t: returns {path, pieceT, ...}
  Figure.prototype.render = function (t) {
    this.lastT = t;
    var S = this.S, FX = this.FX, RT = this.RT, multi = this.multi, n = this.n, k;
    // Reset: the root and the hair inside the skin stay in full ink; only what changes fades.
    // Reset: the whole hair fades out as one, then the uncut hair fades in as one.
    var sh = this.sh, fade = 1, tt = t;
    if (t >= sh.r0 && t < sh.r0 + .45) fade = 1 - easeInOut(seg(t, sh.r0, sh.r0 + .45));
    if (t >= sh.r0 + .45) { fade = t < sh.r0 + .55 ? 0 : easeInOut(seg(t, sh.r0 + .55, sh.loop)); tt = 0; }
    var fo = f(fade * 100) / 100;
    [this.hairs, this.bump].forEach(function (e) { e.style.opacity = fo; });

    // blades
    var ex = this.edgeX(tt);
    for (k = 0; k < n; k++) {
      var bx = ex - k * PITCH, b = this.blades[k], show = bx > -40 && bx - BL * Math.cos(TH) < this.W + 40;
      b.style.display = show ? '' : 'none';
      if (show) { var bp = this.bladePath(bx, S); b.childNodes[0].setAttribute('d', bp[0]); b.childNodes[1].setAttribute('d', bp[1]); }
    }

    // pull: each edge drags the hair up as it arrives, then cuts it at the surface
    var c = this.cross, cut = 0, pull = 0;
    for (k = 0; k < n; k++) if (tt >= c[k]) cut = k + 1;
    // the hair only moves once an edge touches it; it is dragged up through the contact, then cut
    var prog = cut < n ? easeInOut(seg(ex - cut * PITCH, FX - CZ, FX + CZ)) : 0;
    if (multi && cut < n) pull = LIFT[cut] * prog;

    // the whole hair, root and all, rides up by u while the edges drag it, then settles back
    var u = 0;
    if (multi) {
      if (tt < this.rel0) { for (k = 0; k < cut; k++) u += LIFT[k]; u += pull; }
      else u = this.E * (1 - easeOut(seg(tt, this.rel0, this.rel1)));
    }
    var bu = u * BULB;   // the root bulb rises a little; the shaft takes the rest of the pull
    this.root.setAttribute('transform', 'translate(0 ' + f(-bu) + ')');
    var p = '', root = 'M' + FX + ' ' + f(RT + 2 - bu), stub = '', rg = '';
    this.top.setAttribute('d', '');
    this.top.removeAttribute('transform');
    if (cut === 0) {
      // in skin: root to the surface; above it: the pulled length and the uncut hair, leaning with the stroke
      p = root + 'L' + FX + ' ' + f(S + 1);
      this.top.setAttribute('d', 'M' + (FX - HW / 2) + ' ' + (S + 3) + 'H' + (FX + HW / 2) + 'V' + f(S - pull - .5) + 'H' + (FX - HW / 2) + 'Z' + longHair(FX, S - pull));
      if (prog > 0) this.top.setAttribute('transform', 'rotate(' + f(28 * prog) + ' ' + FX + ' ' + S + ')');
    } else if (multi && tt < this.rel1) {
      if (tt < this.rel0) {
        p = root + 'L' + FX + ' ' + S;
        if (pull > .2) {
          // the dragged length stands proud of the skin, leaning with the stroke, square-ended
          var ang = 24 * Math.PI / 180 * (pull / LIFT[cut]), ca = Math.cos(ang), sa = Math.sin(ang), w = HW / 2;
          stub = 'M' + [[-w, 3], [w, 3], [w, -pull], [-w, -pull]].map(function (q) {
            return f(FX + q[0] * ca - q[1] * sa) + ' ' + f(S + q[0] * sa + q[1] * ca);
          }).join('L') + 'Z';
        }
      } else {
        p = root + 'L' + FX + ' ' + f(S + this.E - u);
      }
    } else {
      // after the cut (single) or after release (multi): rest, then regrowth
      var gr = easeInOut(seg(tt, sh.g0, sh.g1));
      if (!multi) { p = root + 'L' + FX + ' ' + (S - (gr > 0 ? 2 : 0)); rg = gr > 0 ? spike([[FX, S], [FX, S - 58 * gr]], 30) : ''; }
      else { p = root + 'L' + FX + ' ' + f(S + this.E - (gr > 0 ? 2 : 0)); rg = gr > 0 ? spike(this.curl(gr), 30) : ''; }
    }
    this.shaft.setAttribute('d', p);
    this.stub.setAttribute('d', stub);
    this.regrow.setAttribute('d', rg);

    // the cut-off length is thrown clear, ahead of the first edge
    var pc = '';
    if (cut >= 1 && tt < c[0] + 1.1) {
      var dt = tt - c[0], pu = easeOut(seg(dt, 0, .9));
      var px = this.edgeX(tt) - this.edgeX(c[0]);
      var b0 = multi ? LIFT[0] : 0;
      this.piece.setAttribute('transform', 'translate(' + f(FX + px * .92 + 26 * easeOut(seg(dt, 0, .25))) + ' ' + f(S - 46 * pu) + ') rotate(' + f(28 + 22 * pu) + ')');
      pc = 'M' + (-HW / 2) + ' 0H' + (HW / 2) + 'V' + (-b0 - .5) + 'H' + (-HW / 2) + 'Z' + longHair(0, -b0);
      // it leaves at the lean it was cut at
      this.piece.style.opacity = 1 - seg(dt, .35, 1.05);
    }
    this.piece.setAttribute('d', pc);

    // each trimming lies along the front face of the blade that cut it and rides away on it
    var dx = -Math.cos(TH), dy = -Math.sin(TH), nx = Math.sin(TH), ny = -Math.cos(TH);
    for (k = 1; k < n; k++) {
      var sv = this.slivers[k - 1], sd = '';
      if (cut > k && tt < c[k] + 1) {
        var sdt = tt - c[k], su = easeOut(seg(sdt, 0, .5)), ek = this.edgeX(tt) - k * PITCH, along = 8 + 18 * su, off = BT + HW / 2 - 2;
        sv.setAttribute('transform', 'translate(' + f(ek + dx * along + nx * off) + ' ' + f(S + dy * along + ny * off) + ') rotate(' + f(-38 * su) + ')');
        sd = 'M' + (-HW / 2) + ' 0H' + (HW / 2) + 'V' + (-LIFT[k]) + 'H' + (-HW / 2) + 'Z';
        sv.style.opacity = 1 - seg(sdt, .6, .95);
      }
      sv.setAttribute('d', sd);
    }

    // the bump over a trapped hair
    if (multi) {
      var hb = 22 * easeInOut(seg(tt, sh.b0, sh.b1)), bx0 = FX - 30, bx1 = FX + 108, bc = FX + 44, SL = this.SL;
      var dome = function (h) { return 'M' + bx0 + ' ' + SL + 'C' + (bc - 36) + ' ' + SL + ' ' + (bc - 38) + ' ' + f(SL - h) + ' ' + bc + ' ' + f(SL - h) + 'C' + (bc + 38) + ' ' + f(SL - h) + ' ' + (bc + 36) + ' ' + SL + ' ' + bx1 + ' ' + SL; };
      this.bump.style.display = hb > .3 ? '' : 'none';
      if (hb > .3) {
        this.bumpClip.setAttribute('d', dome(hb) + 'Z');
        this.bumpKnock.setAttribute('d', 'M' + (bx0 + 6) + ' ' + SL + 'H' + (bx1 - 6));
        this.bumpLine.setAttribute('d', dome(hb));
      }
    } else this.bump.style.display = 'none';

    // the measure: Fig. 1 once the stub has dropped below the skin, Fig. 2 once the cut is made
    var mOn = multi ? seg(tt, this.rel1, this.rel1 + .5) : (cut ? seg(tt, c[0] + .4, c[0] + .9) : 0);
    this.measure.style.opacity = f(mOn * fade * 100) / 100;

  };

  // Regrowth of a hair cut below the surface: up to just under the skin, then turned aside and back in.
  Figure.prototype.curlPts = function () {
    if (this._curl) return this._curl;
    var FX = this.FX, S = this.S, pts = [[FX, S + this.E]], i, u, a;
    var C = [[[FX, S + 40], [FX, S + 20], [FX + 18, S + 15], [FX + 44, S + 18]],
             [[FX + 44, S + 18], [FX + 62, S + 20], [FX + 72, S + 28], [FX + 66, S + 37]]];
    pts.push([FX, S + 40]);
    C.forEach(function (P) {
      for (i = 1; i <= 16; i++) {
        u = i / 16; a = 1 - u;
        pts.push([a * a * a * P[0][0] + 3 * a * a * u * P[1][0] + 3 * a * u * u * P[2][0] + u * u * u * P[3][0],
                  a * a * a * P[0][1] + 3 * a * a * u * P[1][1] + 3 * a * u * u * P[2][1] + u * u * u * P[3][1]]);
      }
    });
    var L = [0];
    for (i = 1; i < pts.length; i++) L.push(L[i - 1] + Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]));
    return (this._curl = { pts: pts, L: L });
  };
  Figure.prototype.curl = function (gr) {
    var c = this.curlPts(), want = c.L[c.L.length - 1] * gr, out = [c.pts[0]];
    for (var i = 1; i < c.pts.length; i++) {
      if (c.L[i] <= want) { out.push(c.pts[i]); continue; }
      var u = (want - c.L[i - 1]) / (c.L[i] - c.L[i - 1]);
      out.push([c.pts[i - 1][0] + (c.pts[i][0] - c.pts[i - 1][0]) * u, c.pts[i - 1][1] + (c.pts[i][1] - c.pts[i - 1][1]) * u]);
      break;
    }
    return out;
  };

  function init() {
    var all = [].slice.call(document.querySelectorAll('svg[data-follicle]')).map(function (s) { return new Figure(s); });
    window.FollicleFigure = Figure;
    var figs = all.filter(function (fg) { return !fg.svg.closest('[data-follicle-carousel]'); });
    window.__fdAll = all;
    document.dispatchEvent(new CustomEvent('follicle:ready', { detail: { figs: all } }));
    window.__fd = { figs: figs, LOOP: LOOP, shared: SHARED };
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    figs.forEach(function (fg) { fg.render(still ? SHARED.r0 - .5 : 0); });
    if (still) return;
    if (/[?&]t=([\d.]+)/.test(location.search)) { var ft = +RegExp.$1; figs.forEach(function (fg) { fg.render(ft); }); return; }
    var live = new Set(), raf = 0;
    function frame(now) {
      live.forEach(function (fg) {
        if (fg.start == null) fg.start = now;
        fg.render(((now - fg.start) / 1000) % LOOP);
      });
      raf = live.size ? requestAnimationFrame(frame) : 0;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var fg = figs.filter(function (x) { return x.svg === e.target; })[0];
        if (e.isIntersecting) { if (!live.has(fg)) fg.start = null; live.add(fg); } else live.delete(fg);
      });
      if (live.size && !raf) raf = requestAnimationFrame(frame);
    }, { threshold: .35 });
    figs.forEach(function (fg) { io.observe(fg.svg); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
